import { ClaimYourProfileAd, ExpertTiersAd, SecondOpinionAd, SignUpAd, SymptomCheckerAd } from '@medifind/ads';
import { useRouter } from '@medifind/router';
import styles from './DoctorProfileAds.module.scss';

const DoctorProfileAds = ({ personId, doctor }) => {
  const router = useRouter();
  const { query } = router;
  const { personId: queryPersonId } = query || {};
  return (
    <div className={styles['ads-container']}>
      <SignUpAd
        classes={{ container: styles['ad'] }}
        tagLine={`Want to save this  ${doctor?.isUSPrescriber ? 'doctor' : 'expert'} for later?`}
        loginMessage={`You can save ${doctor?.isUSPrescriber ? 'doctor' : 'expert'} with a MediFind account.`}
      />
      {doctor?.isUSPrescriber && <SecondOpinionAd personId={queryPersonId} classes={{ container: styles['ad'] }} />}
      {personId && <SymptomCheckerAd page={'doctor'} order={3} tourType={'hint'} classes={{ container: styles['ad'] }} />}
      <ExpertTiersAd classes={{ container: styles['ad'] }} />
      <ClaimYourProfileAd classes={{ container: styles['ad'] }} />
    </div>
  );
};

export { DoctorProfileAds as default, DoctorProfileAds };
